
export const hasPermission = (userPermissionsData, group, resource) => {
    const re = new RegExp(`^${resource}`);
    return userPermissionsData[`ui:${group}`] && userPermissionsData[`ui:${group}`].some(resourceTmp => resourceTmp.match(re));
}
